__webpack_require__.p = "/werewolf-assistant/";